export const satsToBtc = (sats: number | null): number => {
  if (sats == null) {
    return NaN;
  }

  if (typeof sats !== 'number') {
    return sats;
  }
  return sats / 100000000;
};
